import { styled as muiStyled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { abyssColors } from '@/theme/colors';

interface ButtonProps {
  contained?: boolean;
  hideBorder?: boolean;
}

export const PanelHeader = muiStyled(Box)(() => ({
  padding: '1.6rem 2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  borderBottom: '1px solid rgba(101, 130, 164, 0.20)',
}));

export const PanelFooter = muiStyled(Box)(() => ({
  padding: '1.2rem 2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: '0.8rem',
  flexShrink: 0,
  borderTop: '1px solid rgba(101, 130, 164, 0.20)',
}));

export const ActionButton = muiStyled(Button)(({ contained = false }: ButtonProps) => ({
  padding: '0.8rem 1.8rem',
  height: '3rem',
  borderRadius: '0.4rem',
  fontSize: '1.2rem',
  background: contained ? abyssColors.primary[500] : 'transparent',
  color: contained ? abyssColors.neutral[50] : abyssColors.primary[500],
  boxShadow: 'none',
  textTransform: 'none',
  width: 'fit-content',
  lineHeight: 'normal',
  marginLeft: '0px !important',
  '&:disabled': {
    background: contained ? abyssColors.neutral[300] : 'transparent',
    color: contained ? abyssColors.neutral[50] : abyssColors.primary[300],
  },
  '&:hover': {
    background: contained ? abyssColors.primary[400] : 'rgba(0,0,0,0.04)',
  },
}));

export const indexStyles = {
  fontSize: '1.2rem',
  color: '#000000',
  minWidth: '1.6rem',
  flexShrink: 0,
  textAlign: 'right',
  alignSelf: 'center',
  marginRight: '0.8rem',
};

export const draggableIconStyles = {
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  px: '0.4rem',
};
